import { render, staticRenderFns } from "./ScreenView.vue?vue&type=template&id=7e50da6c&scoped=true"
import script from "./ScreenView.vue?vue&type=script&lang=js"
export * from "./ScreenView.vue?vue&type=script&lang=js"
import style0 from "./ScreenView.vue?vue&type=style&index=0&id=7e50da6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50da6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e50da6c')) {
      api.createRecord('7e50da6c', component.options)
    } else {
      api.reload('7e50da6c', component.options)
    }
    module.hot.accept("./ScreenView.vue?vue&type=template&id=7e50da6c&scoped=true", function () {
      api.rerender('7e50da6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/ScreenView.vue"
export default component.exports